/**
 * Hook to access company context.
 * Throws error if used outside CompanyProvider.
 */

import { useContext } from 'react';
import { CompanyContext } from '../contexts/CompanyContext';
import type { CompanyContextType } from '../contexts/CompanyContext';

export function useCompany(): CompanyContextType {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
}
